import ko from "knockout";
import dateHelper from "flow/utils/dateHelper";
import metaCache from "flow/utils/metaCache";

function setup() {
    ko.validation.rules["noFutureDate"] = {
        validator: function (value: string) {
            if (dateHelper.isValidDateFormat(value)) {
                return dateHelper.isInFuture(dateHelper.toDate(value)) === false;
            }

            return true;
        },
        message: metaCache.lookup(
            "FlowHtml.Translations.FutureDateNotAllowed",
            "FlowHtml.Translations.FutureDateNotAllowed"
        )
    };
}

export default {
    setup: setup
};
